import React, {useEffect, useState} from "react";
import Logo from "../../components/logo/Logo";
import {useNavigate, useSearchParams} from "react-router-dom";

function ResetRequestPage() {
    const [searchParams] = useSearchParams();
    const [isAgent, setIsAgent] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        if (searchParams.get("auth-type") === "agent") {
            setIsAgent(true)
        }
        setRedirectUrl(searchParams.get("redirect_url"));
    }, [setIsAgent, searchParams]);

    return <div className="flex min-h-full flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="cp-bg-gray mt-10 sm:rounded-lg sm:mx-auto sm:w-full sm:max-w-[480px]">
            <div className="bg-white py-4 px-16 m-8 rounded-lg">
                <Logo/>
            </div>

            <h2 className="mt-6 text-center text-2xl font-bold leading-9 tracking-tight text-gray-100 p-4">
                Votre mot de passe a été modifié avec succès !
            </h2>

            <div className="w-full text-center p-8">
                <button
                    onClick={() => navigate("/login?redirect_url=" + redirectUrl + (isAgent ? "&auth-type=agent" : ""))}
                    type="submit"
                    className="mt-0 flex w-full justify-center rounded-md cp-bg-orange px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:cp-bg-orange-light focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                    Retour à la page de connexion
                </button>
            </div>
        </div>
    </div>
}

export default ResetRequestPage;
